import { render, staticRenderFns } from "./BatchControlPoint.vue?vue&type=template&id=244857f2&"
import script from "./BatchControlPoint.vue?vue&type=script&lang=js&"
export * from "./BatchControlPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports